import $api from "../../../axios"
import { IProject } from "../types/projectData.types"

const projectsPath = "/projects"

const getProjectData = async (projectId: string): Promise<IProject> => {
  const response = await $api.get(projectsPath + "/project", { params: { projectId } })
  return response.data
}

export default {
  getProjectData,
}
